import React from 'react';
import { getCurrentUser } from '../../profile/services';
import { useGroupPosts } from '../../social/hooks/useSocialFeedRest';
import POSTComponent from '../../social/components/POSTComponent';
import { isSquadManager } from '../utils/squadRoles';

/**
 * PostsTab - Group Posts Management
 *
 * Props:
 * - voProvider: SquadDetailsProvider instance (required)
 */
const PostsTab = ({ voProvider }) => {
  if (!voProvider) {
    return (
      <div className="rounded-lg p-8 text-center">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
        </div>
      </div>
    );
  }

  const squad = voProvider.getGroup();
  const groupId = squad?.id;
  const currentUser = getCurrentUser();
  const currentUserId = currentUser?.id;

  const {
    posts,
    loading: postsLoading,
    createGroupPost,
    reactToGroupPost,
    deleteGroupPost,
    updateGroupPost,
  } = useGroupPosts(groupId, true);

  const handleCreatePost = async (text, imageUrls, privacy) => {
    return createGroupPost({ text, imageUrls, privacy });
  };

  const handleReactToPost = async (postId, type) => {
    if (!postId || !reactToGroupPost) return;
    try {
      const result = await reactToGroupPost(postId, type);
      if (result && !result.success) {
        console.error('Failed to react to post:', result.error);
      }
    } catch (error) {
      console.error('Error reacting to post:', error);
    }
  };

  const handleDeletePost = async (postId) => {
    if (!deleteGroupPost) return;
    const result = await deleteGroupPost(postId);
    if (!result?.success) throw new Error(result?.error || 'Failed to delete post');
  };

  return (
    <POSTComponent
      posts={posts}
      loading={postsLoading}
      canPost={squad?.isMember}
      onCreatePost={handleCreatePost}
      onReactToPost={handleReactToPost}
      onDeletePost={handleDeletePost}
      onPostUpdated={updateGroupPost}
      currentUserId={currentUserId}
      isAdmin={isSquadManager(squad?.userRole)}
      placeholder={`What's on your mind, ${currentUser?.firstName || 'there'}?`}
      maxLength={5000}
      defaultPrivacy="public"
      emptyMessage={squad?.isMember ? 'Be the first to share something!' : 'Join the group to see posts'}
      allowVideoUpload={squad?.privacy === 'private'}
    />
  );
};

export default PostsTab;
